import React, {FC} from 'react';
import {createGetServerSideProps, StaticPageProps} from "../../evcharging/app";
import Page from "../../evcharging/components/Page";
import Navigation from "../../evcharging/containers/layout/Navigation";
import RequestConsultation from "../../evcharging/containers/layout/RequestConsultation";
import Footer from "../../evcharging/containers/layout/Footer";
import {REBATES_LINK} from "../../evcharging/app/seo/pages";
import {I18nPage} from "../../i18n/types/pages.enum";
import RebatesApplications from "../../evcharging/containers/rebates-for-our-ev-partners/RebatesApplications";
import RebatesNationwide from "../../evcharging/containers/rebates-for-our-ev-partners/RebatesNationwide";
import RebatesPartner from "../../evcharging/containers/rebates-for-our-ev-partners/RebatesPartner";
import RebatesCard from "../../evcharging/containers/rebates-for-our-ev-partners/RebatesCard";
import {
  BackOfficeIcon,
  PartnersIcon,
  ProcessIcon,
  RebateIcon, RebatesPartnersIcon,
  SavingsIcon,
  StatesIcon
} from "../../assets/svgs/evc-charging";
import RebatesHeader from "../../evcharging/containers/rebates-for-our-ev-partners/RebatesHeader";
import {
  alabamaPower,
  atlanticCityElectric, austinEnergy, BED, bge,
  blackHillsEnergy, brickellEnergy,
  centralHudson, chargeUpNewJersey,
  coloradoEnergyOffice, comed,
  conEdison, consumersEnergy,
  edisonLogo,
  efficiencyWorks, elPasoElectric, evergy,
  EVERSOURCE, EWEB, GRE, indianaMichiganPower,
  jerseyCentralPower,
  maryland,
  massDEP, michiganChargeUp, mississippiPower,
  nationalgrid, NDEP,
  NPU,
  NYSEG, nyserda, orangeRockland,
  pacificPower, partnerLogo, peco, PGE, PNM,
  PSE,
  PSEG,
  RG,
  rockyMountainPower, sanJoaquinValley,
  siliconValley, TPU,
  uniSourceEnergyServices, unitedIlluminating,
  unitil, vermontCharge
} from "../../assets/evc/partnersLogo";


const listLogo =[
  {image: nationalgrid},
  {image: centralHudson},
  {image: atlanticCityElectric},
  {image: rockyMountainPower},
  {image: uniSourceEnergyServices},
  {image: blackHillsEnergy},
  {image: EVERSOURCE},
  {image: maryland},
  {image: jerseyCentralPower},
  {image: unitedIlluminating},
  {image: edisonLogo},
  {image: PSE},
  {image: NDEP},
  {image: NYSEG},
  {image: PSEG},
  {image: BED},
  {image: siliconValley},
  {image: pacificPower},
  {image: orangeRockland},
  {image: unitil},
  {image: coloradoEnergyOffice},
  {image: RG},
  {image: efficiencyWorks},
  {image: partnerLogo},
  {image: conEdison},
  {image: nyserda},
  {image: massDEP},
  {image: peco},
  {image: EWEB},
  {image: vermontCharge},
  {image: sanJoaquinValley},
  {image: alabamaPower},
  {image: NPU},
  {image: brickellEnergy},
  {image: evergy},
  {image: bge},
  {image: michiganChargeUp},
  {image: indianaMichiganPower},
  {image: consumersEnergy},
  {image: GRE},
  {image: mississippiPower},
  {image: chargeUpNewJersey},
  {image: elPasoElectric},
  {image: PNM},
  {image: PGE},
  {image: austinEnergy},
  {image: TPU},
  {image: comed},
]

const listItems = [
  {title: 'Back-Office Support', text: 'We handle all paperwork, so our business partners can focus more on their operations.', icon: <BackOfficeIcon />},
  {title: 'Covering All 50 States', text: 'Energy5 connects business partners to rebates across the U.S., securing savings wherever they operate.', icon: <StatesIcon />},
  {title: 'Targeted Rebate Matching', text: 'We find and match our partners with eligible rebate programs—national, state, and regional.', icon: <RebateIcon />},
  {title: 'Trusty Rebates Partners', text: 'Leading rebate programs (e.g., NationalGrid, NYSERDA, EverSource) recognize Energy5 as a reliable and accurate applicant.', icon: <RebatesPartnersIcon />},
  {title: 'Compliance for Maximum Savings', text: 'Energy5 ensures partner applications meet requirements, maximizing rebate benefits.', icon: <SavingsIcon />},
  {title: 'Smooth, End-to-End Process', text: 'We manage every step of the rebate process for our partners, keeping it organized and easy.', icon: <ProcessIcon />},
  {title: 'Trusted by 1,000+ Partners', text: 'Over 1,000 businesses rely on us to secure top rebates and maximize savings.', icon: <PartnersIcon />},
]

const RebatesForOurEvPartners: FC<StaticPageProps> = ({page}) => (
  <Page
    title={'Rebates for our EV Partners'}
    description={'Rebates for our EV Partners'}
  >
    <Navigation/>
    <RebatesHeader />
    <RebatesCard listItems={listItems} />
    <RebatesApplications text={'Successful Applications'}/>
    <RebatesNationwide
      text={'Wherever you are, Energy5 connects you to top rebates across the U.S.'}
      blackTitle={'Available '}
      yellowTitle={'Nationwide'}
    />
    <RebatesPartner text={'Trusted Rebates Partner'} listLogo={listLogo} />
    <RequestConsultation isRebatesForm/>
    <Footer/>
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  REBATES_LINK,
  undefined,
  [I18nPage.EvChargingCommon, I18nPage.EvChargingHome, I18nPage.EnergyRates, I18nPage.Blog]
);

export default RebatesForOurEvPartners;
